module.exports = __webpack_public_path__ + "img/notesbtn.d672030e.png";